import { ReactNode } from 'react';

import { PaginationProvider } from './pagination';

export default function AppProvider({ children }: { children: ReactNode }) {
  return <PaginationProvider>{children}</PaginationProvider>;
}
